<template>
  <div>
    <label>Motorista</label>

    <div class="w3-row">
      <div class="w3-col s4 l2">
        <input
          type="text"
          @keyup.enter="inserirDadoPorChave()"
          ref="motorista"
          class="w3-input w3-border input-codigo"
          v-model="chave_pesquisa"
          :disabled="somenteLeitura == 'S'"
          v-bind:placeholder="placeholder_codigo"
          v-on:blur="onBlurChave()"
          maxlength="15"/>
      </div>

      <div class="w3-col s8 l10">
        <div class="input-container">
          <input
            class="input-registro-selecionado w3-border"
            type="text"
            v-model="motorista_selecionado.nome_razao_social"
            @click="abrirPesquisa"
            :disabled="somenteLeitura == 'S'"
            placeholder="Clique para selecionar o motorista"
            readonly/>

          <i
            v-if="somenteLeitura == 'N'"
            class="fas fa-minus icone w3-border-top w3-border-right w3-border-bottom"
            @click="limparDados"/>
        </div>
      </div>
    </div>

    <pesquisa-motoristas
      ref="pesquisaMotoristas"
      @confirmar="carregar">
    </pesquisa-motoristas>

  </div>
</template>

<script>
  import RMotorista from '@/components/Rest/RMotorista'
  import Biblioteca from '@/components/Repositorio/Biblioteca'
  import pesquisaMotoristas from '@/components/Pesquisas/pesquisaMotoristas'

  export default {
    name: 'FrameMotorista',

    components: {
      pesquisaMotoristas
    },

    props: {
      somenteLeitura: {
        required: true,
        type: String,
        default: 'N'
      },

      /*
        Caso necessite preencher o motorista no create, informar nesta property
        Caso que isso acontece:
          - Caso o frame esteja em um v-if (que recria o elemento a medida que a condição muda).
          Exemplo: Clientes simplificados.
      */
      motoristaSelecionado: {
        required: false,
        type: Object,
        default: function () {
          return {}
        }
      }
    },

    data() {
      return {
        motorista_selecionado: {},
        chave_pesquisa: '',
        placeholder_codigo: 'Cód.'
      }
    },

    methods: {
      /* Utilizado apenas no evento do campo */
      async inserirDadoPorChave(chave) {

        if (this.valorInt(chave) > 0){
          this.chave_pesquisa = chave;
        }

        let motorista_id = this.valorInt(this.chave_pesquisa);

        if 
          (
            (this.chave_pesquisa == '') ||
            (motorista_id <= 0)
          )
        {
          Biblioteca.exclamar('Digite um código válido!');
          return;
        }  

        try {

          let parametros = {
            tipo: 'COD',
            chave: motorista_id
          }

          let retorno = await RMotorista.buscarMotorista(this.axios, parametros);
          if (retorno.houve_erro != 'N') {
            throw new Error(retorno.mensagem);
          }

          this.carregar(JSON.parse(JSON.stringify(retorno.dados[0])));
        }
        catch (e) {
          this.limparDados();
          Biblioteca.exclamar(e.message);
        }
      },

      abrirPesquisa() {
        this.$refs.pesquisaMotoristas.abrir();
      },

      /* Aplica as modificações visuais do frame quando um cliente é selecionado */
      carregar(motorista, carregando_offline) {
        this.chave_pesquisa = '';

        if ((!motorista) || (!motorista.motorista_id)) {
          this.limparDadosComponente();
          return;
        }
        
        this.motorista_selecionado = JSON.parse(JSON.stringify(motorista));
        this.placeholder_codigo = Biblioteca.nPadrao(
          this.motorista_selecionado.motorista_id,
          0
        );

        if (!carregando_offline){
          this.$emit('confirmar', this.motorista_selecionado);
        }
      },

      onBlurChave() {
        if (this.motorista_selecionado.motorista_id) {
          if (this.motorista_selecionado.motorista_id != this.valorInt(this.chave_pesquisa)) {
            this.chave_pesquisa = '';
          }
        }
        else {
          this.limparDados();
        }
      },

      limparDadosComponente(){
        this.chave_pesquisa = '';
        this.placeholder_codigo = 'Cód.';
        this.motorista_selecionado = {};
      },
     
      limparDados() {
        this.limparDadosComponente();        
        this.$emit('limparDados');
      },

      valor(numero_str) {
        return Biblioteca.valor(numero_str);
      },

      valorInt(numero) {
        return Biblioteca.valorInt(numero);
      }
    },

    created() {
      if (this.motoristaSelecionado) {
        this.carregar(this.motoristaSelecionado);
      }
    }
  }
</script>

<style escoped>
  .card-item {
    background-color: #f3f3f3;
    border-radius: 10px;
    box-shadow: #f3f3f3 1px 3px 5px 3px ;
    margin-bottom: 5px;
    padding: 3px !important;
  }

  .input-codigo {
    padding: 10px 15px;
    border-radius: 0px;
    position: relative;
    z-index: 0;
    font-weight: bold;
    border-right-style: none!important;
  }

  .input-container {
    display: -ms-flexbox; 
    display: flex;
    position: relative;
    z-index: 1;
    margin-left: -20px;
    width: calc(100% + 20px);
  }

  .icone {
    padding: 11px;
    background: gray;
    color: white;
    min-width: 15px;
    text-align: center;
    border-left-style: none
  }

  .icone:active {
    background-color: #ccc;
    box-shadow: 0 1px #666;
    transform: translateY(1px);
  }

  .input-registro-selecionado {
    width: 100%;
    padding: 10px;
    outline: none;
    cursor: pointer;
    font-weight: bold;
    border-right-style: none;
  }

</style>


// WEBPACK FOOTER //
// src/components/Frames/FrameMotorista.vue